import React from 'react'
import { LocationContractScreensRouterProps } from './interfaces';
import { TAB_NUMBER } from '../../../ContractScreensView/constants';
import InactiveCycleContractList from '../InactiveCycleContractList/InactiveCycleContractList';
import CompletedCycleContractList from '../CompletedCycleContractList/CompletedCycleContractList';
import ActiveContractCyclesList from '../ActiveContractCyclesList/ActiveContractCyclesList';

const LocationContractOverviewRouter: React.FC<LocationContractScreensRouterProps> = ({ tabNumber }) => {
  switch (tabNumber) {
  case TAB_NUMBER.INACTIVE:
    return <InactiveCycleContractList />;
  case TAB_NUMBER.ACTIVE:
    return <ActiveContractCyclesList />;
  case TAB_NUMBER.COMPLETED:
    return <CompletedCycleContractList />;
  default:
    return null;
  }
}

export default LocationContractOverviewRouter;
